<template>
    <div class="landing-page-mobile">
        <v-card class="landing-card" elevation="0" :image="landingpage_mobile" width="100%">
            <v-card-text>
                <div class="top-bar">
                    <img :src="pia_logo_white" alt="Logo" class="logo" />
                    <v-icon class="logout-icon" @click="handleLogout">mdi-logout</v-icon>
                </div>

                <div class="user-info">
                    <v-avatar size="70" class="user-avatar" v-if="profileLoaded">
                        <v-img :src="userProfile?.profileImage" />
                    </v-avatar>
                    <v-avatar size="100" v-else>
                        <v-img :src="Avatar_3D" />
                    </v-avatar>

                    <div class="user-text">
                        <p class="welcome-text">Hi, {{ tokenProfile?.name }}</p>
                        <p class="date-text">{{ moment(date).format('ddd, DD MMMM YYYY') }}</p>
                        <WeatherMini :weather-temp="parseFloat(weatherTemp)" :weather-humidity="weatherHumidity"
                            :weather-wind="weatherWind" :weather-rain="weatherRain" :city="weatherLocation" />
                    </div>
                </div>
            </v-card-text>

            <v-col class="mt-2">
                <LandingPageWorkLocationMobile />
            </v-col>

            <v-col class="mt-2">
                <LandingPageFunctionsMobile />
            </v-col>
        </v-card>

        <div class="footer-container">
            <p class="footer-text">{{ $t('landing-page.pinestack-rights') }}</p>
            <div class="footer-links">
                <a href="https://pinestack.io/en/contact/" class="footer-link" target="_blank">
                    {{ $t('landing-page.contact-us') }}
                </a>
                <a href="https://pinestack.io/en/privacy-policy/" class="footer-link" target="_blank">
                    {{ $t('landing-page.privacy-policy') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, defineProps } from 'vue'
import WeatherMini from './WeatherMini.vue'
import AnimatedButton from '@/components/general/ChildComponents/AnimatedButton.vue'
import WeatherLocationMobile from './WeatherLocationMobile.vue'
import LandingPageFunctionsMobile from './LandingPageFunctionsMobile.vue'
import LandingPageWorkLocationMobile from './LandingPageWorkLocationMobile.vue'
import { performLogout } from '@/controllers/BackboneAPI'
import moment from 'moment'
import pia_logo_white from '@/assets/Branding/Pia/pia_logo_white.png'
import landingpage_mobile from '@/assets/General/landingpage_mobile.png'
import { useI18n } from 'vue-i18n'
import Avatar_3D from '@/assets/General/Avatar_3D.png'
import { useOAuthService } from '@/services/OAuthService'

const props = defineProps({
    userProfile: { type: [Object, null], required: true },
    profileLoaded: { type: Boolean, required: true }
})

const weatherTemp = ref(0)
const weatherHumidity = ref(0)
const weatherWind = ref(0)
const weatherRain = ref(0)
const weatherLocation = ref('Munich')
const currentTime = ref(moment().format('HH:mm:ss'))
const date = ref(new Date())
const { locale, t } = useI18n()
const tokenProfile = ref(null)

const apiKey = '4ae793a3dd93a074ff16d7e97b06ec5b'
const city = 'Munich'

async function fetchWeather() {
    const response = await fetch(`https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`)
    const data = await response.json()
    weatherTemp.value = data.main.temp.toFixed(1)
    weatherHumidity.value = data.main.humidity
    weatherWind.value = data.wind.speed
    weatherRain.value = data.rain ? data.rain['1h'] : 0
    weatherLocation.value = city
}

onMounted(async () => {
    try {
        await fetchWeather()
        tokenProfile.value = await useOAuthService().getUserProfile()
    } catch (error) {
        console.error(error)
    }
})

async function handleLogout() {
    await performLogout()
}

setInterval(() => {
    currentTime.value = moment().format('HH:mm:ss')
}, 1000)
</script>


<style scoped>
.landing-page-mobile {
    background-color: #495ECA;
    min-height: 100vh;
    padding-bottom: 80px;

}

.landing-card {
    background-size: cover;
    background-position: center;
    padding: 14px 16px;
    position: relative;
}

.top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: nowrap;
}

.logo {
    height: 40px;
}

.logout-icon {
    font-size: 26px;
    color: white;
    cursor: pointer;
}

.onevr-logo {
    position: absolute;
    right: 70px;
}

.user-info {
    margin-top: 20px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.user-avatar {
    border: 3px solid white;
    background: rgba(255, 255, 255, 0.3);
}

.user-text {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.welcome-text {
    color: white;
    font-size: 22px;
    font-weight: bold;
}

.date-text {
    color: white;
    font-size: 12px;
    margin-top: 0;
}

.footer-container {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 28px;
    background-color: #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    font-size: 0.75rem;
    color: #718096;
    border-top: 1px solid #e0e0e0;
}

.footer-links {
    display: flex;
    gap: 10px;
}

.footer-link {
    color: #718096;
    text-decoration: none;
}

.footer-link:hover {
    text-decoration: underline;
}

/* 📱 Responsive Breakpoints */
@media (max-width: 770px) {
    .welcome-text {
        font-size: 20px;
    }

    .date-text {
        font-size: 13px;
    }

    .logo {
        height: 35px;
    }

    .user-avatar {
        width: 58px;
        height: 58px;
    }
}

@media (max-width: 550px) {
    .welcome-text {
        font-size: 18px;
    }

    .date-text {
        font-size: 12px;
    }

    .logo {
        height: 32px;
    }

    .user-avatar {
        width: 54px;
        height: 54px;
    }
}

@media (max-width: 450px) {
    .welcome-text {
        font-size: 17px;
    }

    .date-text {
        font-size: 11px;
    }

    .logo {
        height: 30px;
    }

    .user-avatar {
        width: 50px;
        height: 50px;
    }

    .footer-text {
        font-size: 0.65rem;
    }

    .footer-link {
        font-size: 0.65rem;
    }
}

@media (max-width: 380px) {
    .welcome-text {
        font-size: 16px;
    }

    .date-text {
        font-size: 10px;
    }

    .logo {
        height: 28px;
    }

    .user-avatar {
        width: 46px;
        height: 46px;
    }
}
</style>